<template>
  <v-container class="scheduler-calendar">
    <v-row class="px-5 py-2">
      <v-toolbar
        flat
      >
        <v-btn
          outlined
          class="mr-4"
          color="grey darken-2"
          @click="setToday"
        >
          Hoje
        </v-btn>
        <v-btn
          fab
          text
          small
          color="grey darken-2"
          @click="prev"
        >
          <v-icon small>
            mdi-chevron-left
          </v-icon>
        </v-btn>
        <v-btn
          fab
          text
          small
          color="grey darken-2"
          @click="next"
        >
          <v-icon small>
            mdi-chevron-right
          </v-icon>
        </v-btn>
        <v-toolbar-title v-if="$refs.calendar">
          {{ $refs.calendar.title }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu
          bottom
          right
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              color="grey darken-2"
              v-bind="attrs"
              v-on="on"
            >
              <span>{{ lang.scheduler.calendar.types[type] }}</span>
              <v-icon right>
                mdi-menu-down
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(label, type_) in lang.scheduler.calendar.types"
              :key="type_"
              @click="type = type_"
            >
              <v-list-item-title v-text="label" />
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
    </v-row>
    <v-row class="px-5 py-2">
      <v-calendar
        ref="calendar"
        locale="pt-BR"
        v-model="focus"
        :events="data"
        :type="type"
        :event-name="getEventName"
        :event-color="getEventColor"
        event-start="_start"
        event-end="_end"
        :class="`c${type}`"
        color="primary"
      >
        <template v-slot:event="{ event }">
          <Schedule
            :value="event"
            @view="$emit('view', $e)"
            @edit="$emit('edit', $e)"
            noStyle
          />
        </template>
      </v-calendar>
    </v-row>
  </v-container>
</template>

<script>
import Schedule from '@/components/scheduler/launches/templates/Schedule'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import { Launches } from '../../modules/launches.js'

export default {
  components: { Schedule },
  mixins: [ appdata, utils ],
  data: () => ({
    focus: '',
    type: 'month'
  }),
  computed: {
    data () {
      this.get_data.schedules
      let schedules = ((this.get_data.schedules || {}).all || []).map(sch => ({ ...sch, color: this.getRandomColor() })),
          launches = new Launches(schedules, [], [])

      return launches.get(true) || []
    }
  },
  methods: {
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor (event) {
      return event.color
    },
    getEventName ({ input }) {
      return input.name
    },
    setToday () {
      this.focus = ''
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    }
  },
  mounted () {
    this.$refs.calendar.checkChange()
  }
}
</script>

<style lang="scss">
.scheduler-calendar {
  #app & {
    width: 100% !important;
    max-width: unset !important;
    margin: 0px !important;
    padding: 0px !important;
    .v-calendar {
      &-weekly__day {
        .v-event {
          width: 100% !important;
          .schedule-chip {
            height: 20px !important;
            margin-top: 0px !important;
            padding: 0px 7px !important;
            .v-chip__content {
              display: initial;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              i {
                margin-right: 3px !important;
                margin-top: -2px !important;
              }
            }
          }
        }
      }
      &.v-calendar-daily.cweek {
        .v-calendar-daily_head-day {
          width: 203px !important;
        }
        .v-event-timed-container {
          width: 100% !important;
          .v-event-timed .schedule-chip {
            margin: 0px !important;
            padding: 2px 5px !important;
            height: 100% !important;
            width: 100%;
            &:hover {
              z-index: 1 !important;
            }
            .v-chip__content {
              width: 100% !important;
              display: initial;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              i {
                margin-top: -2px !important;
              }
            }
          }
        }
      }
    }
  }
  #app.theme--light & {
    background: #fcfcfc !important;
    box-shadow: 0px 0px 9px -1px rgb(0 0 0 / 10%);
  }
  #app.theme--dark & {
    background: #1E1E1E !important;
    box-shadow: 0px 0px 9px -1px rgb(255 255 255 / 10%);
  }
}
</style>
